import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=16f59733&"
import script from "./SettingPanel.vue?vue&type=script&lang=js&"
export * from "./SettingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=16f59733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports